import { PricingUnitEnum } from './enums/pricing-unit.enum';
import { ServiceTypeEnum } from './enums/offer-service-type.enum';
import { LIST_MEASURE_UNIT, MeasureUnit, MeasureUnitEnum } from './vehicle.model';


export class PricingUnit {

  public code!: PricingUnitEnum;
  public labelKey!: string;
  public weightingTooltipKey?: string;
  public weightingLabelKey?: string;
  public defaultValue?: number;
  public measureUnit?: MeasureUnit;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }

  public isValidForServiceType(serviceType: ServiceTypeEnum): boolean {
    if(serviceType !== ServiceTypeEnum.FTL) {
      return true;
    }
    return [
      LIST_PRICING_UNIT[PricingUnitEnum.KILOMETER].code,
      LIST_PRICING_UNIT[PricingUnitEnum.KILOGRAM].code,
    ].includes(this.code);
  }
}

export const LIST_PRICING_UNIT: { [key: string]: PricingUnit } = {
  PALLET: new PricingUnit({ code: PricingUnitEnum.PALLET, labelKey: 'MEASURE_UNIT.PALLET', weightingLabelKey: 'LABEL.WEIGHTING.PALLET', weightingTooltipKey: 'TOOLTIP.WEIGHTING.PALLET',  defaultValue: 0.5, measureUnit: LIST_MEASURE_UNIT[MeasureUnitEnum.METER] }),
  KILOGRAM: new PricingUnit({ code: PricingUnitEnum.KILOGRAM, labelKey: 'MEASURE_UNIT.KILOGRAM', weightingLabelKey: 'LABEL.WEIGHTING.KILOGRAM', weightingTooltipKey: 'TOOLTIP.WEIGHTING.KILOGRAM', defaultValue: 150, measureUnit: LIST_MEASURE_UNIT[MeasureUnitEnum.KG_CUBIC_METER] }),
  UNIT: new PricingUnit({ code: PricingUnitEnum.UNIT, labelKey: 'MEASURE_UNIT.UNIT' }),
  COL: new PricingUnit({ code: PricingUnitEnum.COL, labelKey: 'MEASURE_UNIT.COL', defaultValue: undefined, weightingLabelKey: 'LABEL.WEIGHTING.COL', weightingTooltipKey: 'TOOLTIP.WEIGHTING.COL', measureUnit: LIST_MEASURE_UNIT[MeasureUnitEnum.LITER] }),
  LDM: new PricingUnit({ code: PricingUnitEnum.LDM, labelKey: 'MEASURE_UNIT.LDM', defaultValue: 1.8, weightingLabelKey: 'LABEL.WEIGHTING.LDM', weightingTooltipKey: 'TOOLTIP.WEIGHTING.LDM', measureUnit: LIST_MEASURE_UNIT[MeasureUnitEnum.TONNE] }),
  KILOMETER: new PricingUnit({ code: PricingUnitEnum.KILOMETER, labelKey: 'MEASURE_UNIT.KILOMETER' }),
};